import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageFormComponent } from '../page-form/page-form.component';


@Component({
  selector: 'p8-bdc-page-new',
  templateUrl: './page-new.component.html',
  styleUrls: ['./page-new.component.scss']
})
export class PageNewComponent implements OnInit {
  @ViewChild(PageFormComponent, { static: true }) pageFormComponent: PageFormComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  onSubmit() {
    this.pageFormComponent.save().subscribe(page => {
      this.router.navigate(['..'], {relativeTo: this.activatedRoute});
    });
  }

  onCancel() {
    this.router.navigate(['..'], {relativeTo: this.activatedRoute});
  }
}

